import { render, staticRenderFns } from "./carbonEmission.vue?vue&type=template&id=ded32334&scoped=true&"
import script from "./carbonEmission.vue?vue&type=script&lang=js&"
export * from "./carbonEmission.vue?vue&type=script&lang=js&"
import style0 from "./carbonEmission.vue?vue&type=style&index=0&id=ded32334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded32334",
  null
  
)

export default component.exports